import * as Yup from 'yup';

export const validation = Yup.object().shape({
	name: Yup.string().required('Condition Name is required'),
});

export const validationRole = [validation, undefined];
